import React, { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Phone, User, MessageSquare } from 'lucide-react';

const CallbackSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    preferredTime: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! Our Umrah specialist will call you back at your preferred time.');
    setFormData({ name: '', phone: '', preferredTime: '' });
  };

  return (
    <section 
      id="callback" 
      className="py-20 relative"
      style={{
        backgroundImage: `url('https://images.pexels.com/photos/87500/pexels-photo-87500.jpeg?auto=compress&cs=tinysrgb&w=1920')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <span className="text-[#d4af37] font-medium tracking-wider">SPEAK TO AN UMRAH EXPERT</span>
            <h2 
              className="text-3xl md:text-4xl font-bold mt-2 mb-6"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              Let Our Umrah Specialists Help You
            </h2>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Have questions about building your Umrah package? Our dedicated team of Umrah 
              specialists are here to help you plan the perfect pilgrimage. No pushy sales - 
              just genuine advice from experts who understand your needs.
            </p>

            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center">
                <Phone className="w-8 h-8 text-white" />
              </div>
              <div>
                <p className="text-gray-400 text-sm">Call Us Directly</p>
                <p className="text-2xl font-bold text-white">01582 800 304</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center">
                <MessageSquare className="w-8 h-8 text-white" />
              </div>
              <div>
                <p className="text-gray-400 text-sm">WhatsApp Support</p>
                <p className="text-2xl font-bold text-white">+44 7404 386262</p>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="bg-white p-8 rounded-lg shadow-xl">
            <h3 
              className="text-2xl font-bold text-gray-900 mb-2"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              Request Call Back
            </h3>
            <p className="text-gray-600 text-sm mb-6">Our Umrah specialist will call you back</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="pl-10 border-gray-300"
                  required
                />
              </div>

              <div className="relative">
                <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="pl-10 border-gray-300"
                  required
                />
              </div>

              <div className="relative">
                <MessageSquare className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  placeholder="Preferred Time to Call"
                  value={formData.preferredTime}
                  onChange={(e) => setFormData({ ...formData, preferredTime: e.target.value })}
                  className="pl-10 border-gray-300"
                />
              </div>

              <Button
                type="submit"
                className="w-full bg-[#d4af37] text-black hover:bg-[#c4a030] font-bold py-3"
              >
                REQUEST CALL BACK
              </Button>
            </form>

            <p className="text-center text-gray-500 text-xs mt-4">
              By submitting, you agree to receive calls about Umrah packages
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallbackSection;
